import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Containers/Home';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Rooms from './Containers/Pages/Rooms';
import AboutUs from './Containers/Pages/AboutUs';
import ContactUs from './Containers/Pages/ContactUs';
import Services from './Containers/Pages/Services';
import PrivacyPolicy from './Containers/Pages/PrivacyPolicy';
import TermConditions from './Containers/Pages/TermConditions';
import CancellationPolicy from './Containers/Pages/CancellationPolicy';
import Account from './Containers/Account/Account';
import AvailableRooms from './Containers/AvailableRooms';
import ProtectedRoute from './Components/ProtectedRoute';
import RoomDetail from './Containers/Account/RoomDetail';
import BookingPage from './Containers/Account/BookingPage';
import BookingConfirmation from './Containers/Account/BookingConfirmation';
import CancelBooking from './Containers/Account/CancelBooking';
import MyBooking from './Containers/Account/MyBooking';
import BookingDetail from './Containers/Account/BookingDetail';
import MyProfile from './Containers/Account/MyProfile';
import ChangePassword from './Containers/Account/ChangePassword';


function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Router>
        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route exact path='/rooms' element={<Rooms />} />
          <Route exact path='/about-us' element={<AboutUs />} />
          <Route exact path='/contact-us' element={<ContactUs />} />
          <Route exact path='/services' element={<Services />} />
          <Route exact path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route exact path='/term-conditions' element={<TermConditions />} />
          <Route exact path='/cancellation-policy' element={<CancellationPolicy />} />

          <Route exact path='/available-rooms' element={<AvailableRooms />} />
          <Route path="/room-detail/:room_name" element={<RoomDetail />} />

          <Route
            path="/booking/:room_name"
            element={
              <ProtectedRoute>
                <BookingPage />
              </ProtectedRoute>

            }
          />
          <Route path="/booking-confirmation/:bookingId" element={<BookingConfirmation />} />
          <Route path="/cancel-booking/:bookingId" element={<CancelBooking />} />


          <Route
            exact
            path="/account"
            element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            }
          />
           <Route exact path="/account/my-profile" element={<MyProfile />} />
           <Route exact path="/account/change-password" element={<ChangePassword />} />
           <Route exact path="/account/my-bookings/" element={<MyBooking />} />
           <Route exact path="/booking-detail/:bookingId" element={<BookingDetail />} />


        </Routes>
      </Router>
    </div>
  );
}

export default App;
